import React, { PropsWithChildren, useState } from 'react';
import { View, Text, useWindowDimensions, Platform, Image, Pressable, Dimensions, Linking } from 'react-native';
import {GlobalVariables} from '../utils/globalVariables';
import { NavigationProp, useRoute } from '@react-navigation/native';
import CreateResponsiveStyle from '../utils/responsiveStyle';
import IconMenu from '../source/icons/menu';
import { enumPages } from '../App';
import { Menu, MenuDivider, MenuItem } from 'react-native-material-menu';
import IconClose from '../source/icons/close';

import ReadProperties from '../utils/comandos.js';
ReadProperties.leerArchivoProps();

type SectionProps = PropsWithChildren<{
  navigation: NavigationProp<any, any>
}>;
export class optionsMenu {
  id: string = '';
  name: string = '';
  disabled?: boolean = false;
}
function HeaderComponent({ navigation }: SectionProps): JSX.Element {
  const route = useRoute();
  const layout = useWindowDimensions();
  const styles = responsiveStyle(layout);
	// +amr
	//amr const queryParams = new URLSearchParams(window.location.search);
	//amr var par = queryParams.get('lab');
   //amr var lab = par ? par : 'POLANCO';
	ReadProperties.leerArchivoProps();
	var lab = GlobalVariables.vars.lab;
	var url = GlobalVariables.vars.url;

/* -amr
	//amr-1 var url = 'https://lmpolanco.com/';
	//amr-1 var url = 'https://laboratoriosruiz.com/';
	if (lab.toUpperCase() === 'POLANCO') {
		url = 'https://lmpolanco.com/';
	} else {
		if (lab.toUpperCase() === 'RUIZ') {
			url = 'https://laboratoriosruiz.com/';
		} else {
			url = 'https://lmpolanco.com/';
		}
	}
	// +amr
-amr */

  const [widthOptions, setWidthOptions] = useState(380);
  const [visibleMenu, setVisibleMenu] = useState(false);
  const [options] = useState(() => {
    const initial: optionsMenu[] = [{
      id: enumPages.inicio,
      name: 'Inicio',
    }, {
      id: enumPages.facturacion,
      name: 'Facturación',
    },
    // {
    //   id: 'resultados',
    //   name: 'Resultados',
    //   disabled: true
    // }
    ];
    return initial;
  });
  const toggleList = () => setVisibleMenu(!visibleMenu);
  const navigationPage = (item: optionsMenu) => {
    navigation.navigate(item.id);
    //amr navigation.navigate(item.id, {lab});
  };
  return (
    <View style={[styles('generalContainer')]} onLayout={(event) => {
      let { width } = event.nativeEvent.layout;
      setWidthOptions(width);
    }}>
      <Menu
        style={{
          width: (widthOptions + 10),
          marginTop: 75,
          backgroundColor: GlobalVariables.colors.primary.darkGrey,
          marginLeft: Dimensions.get('window').width <= GlobalVariables.vars.widthMobile ? 10 : 0,
        }}
        visible={visibleMenu}
        anchor={
          <View style={[styles('container'), {width: widthOptions}]}>
            <View style={[styles('itemsContainer'), styles('firsItemsContainer')]}>
              <Pressable onPress={() => {
					/* -amr let url = 'https://lmpolanco.com/'; -amr */
                if (Platform.OS === 'web') {
                  window.location.href = url;
                } else {
                  Linking.openURL(url);
                }
               }}>
					{/* -amr-1 source={require('../source/icons/logo-lmp-completo.png')} c/lmp/ruiz -amr-1 */}
                <Image
						source={require(lab.toUpperCase() === 'RUIZ' ? '../source/icons/logo-lmp-completo.png' : '../source/icons/logo-lmp-completo.png')}
//amr						source={require(GlobalVariables.vars.log)}
					style={styles('logo')} />
              </Pressable>
            </View>
            <View style={[styles('itemsContainer'), styles('secondItemsContainerMovil')]}>
              <Pressable onPress={toggleList} style={[
                visibleMenu && styles('visibleMenu'),
                styles('menu'),
              ]}>
                {
                  visibleMenu ? <IconClose /> : <IconMenu />
                }
              </Pressable>
            </View>
            <View style={[styles('itemsContainer'), styles('secondItemsContainer')]}>
              {
                options.map(e => {
                  return (
                    <Pressable
                      key={e.id}
                      style={e.disabled && styles('disabled')}
                      onPress={() =>{
                        if (!e.disabled) {
                          navigationPage(e);
                        }
                      }}>
                      <Text
                        style={[
                          styles('textItemsContainer'),
                          route.name === e.id && styles('selected'),
                        ]}>
                        {e.name}
                      </Text>
                    </Pressable>
                  );
                })
              }
            </View>
          </View>
        }
        onRequestClose={toggleList}>
          {
            options.map(e => {
              return (
              <View key={`${e.id}-optionmenu`}>
                <MenuItem style={e.disabled && styles('disabled')} pressColor={GlobalVariables.colors.primary.darkGrey} onPress={()=>{
                  if (!e.disabled) {
                    toggleList();
                    navigationPage(e);
                  }
                }}>
                  <Text style={{color: GlobalVariables.colors.secondary.white}}>{e.name}</Text>
                </MenuItem>
                <MenuDivider color={GlobalVariables.colors.secondary.lightGrey} />
              </View>
              );
            })
          }
      </Menu>
    </View>
  );
}
const responsiveStyle = CreateResponsiveStyle({
  generalContainer: {
    backgroundColor: GlobalVariables.colors.primary.kingBlue,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  container: {
    width: 800,
    maxWidth: 820,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: 30,
    paddingBottom: 30,
    paddingLeft: 15,
    paddingRight: 15,
  },
  itemsContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  textItemsContainer: {
    fontSize: 16,
    color: GlobalVariables.colors.secondary.white,
    marginLeft: 15,
    marginRight: 15,
    fontWeight: '400',
    fontFamily: '"Helvetica Neue LT Std Roman", sans-serif',
    lineHeight: 19,
    letterSpacing: 0.5,
    ...Platform.select({
      web: {
        cursor: 'pointer',
      },
    }),
  },
  selected: {
    borderBottomWidth: 2,
    paddingBottom: 1,
    borderBottomColor: GlobalVariables.colors.secondary.white,
  },
  firsItemsContainer: {
    marginRight: 300,
  },
  secondItemsContainer: {

  },
  secondItemsContainerMovil: {
    display: 'none',
  },
  logo: {
    width: 200,
    height: 30,
  },
  menu:{
    paddingTop: 30,
    paddingBottom: 30,
    paddingLeft: 20,
    paddingRight: 20,
  },
  visibleMenu:{
    backgroundColor: '#020E4E',
  },
  disabled:{
    opacity: 0.7,
    ...Platform.select({
      web: {
        cursor: 'default',
      },
    }),
    pointerEvents: 'none',
  },
}, {
  container: {
    maxWidth: 'auto',
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: 0,
    paddingRight: 0,
  },
  firsItemsContainer: {
    marginRight: 0,
  },
  secondItemsContainer: {
    display: 'none',
  },
  secondItemsContainerMovil: {
    display: 'flex',
  },
  logo:{
    marginLeft: 15,
  },
});
export default HeaderComponent;
